import React from 'react';
import {
  BaseButton,
  BaseDivider,
  BaseTypography,
} from '../../../components/common';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Grid } from '@material-ui/core';

export type PUserPageTitle = {
  title: string;
  description?: string;
  rightContent?: JSX.Element;
};

const useStyles = makeStyles((theme) => ({
  root: {
    // height: '80px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '12px',
    marginBottom: '32px',
    [theme.breakpoints.down('md')]: {
      minHeight: '20px',
      height: 'auto',
      padding: '0',
      marginBottom: '24px',
    },
  },
  divider: {
    margin: 0,
    position: 'absolute',
    left: 0,
    width: '100%',
  },
}));

export const UserPageTitle: React.FC<PUserPageTitle> = (props) => {
  const { title, description, rightContent } = props;
  const classes = useStyles();
  return (
    <>
      <Grid container className='custom'>
        <Grid item xs>
          <div className={`${classes.root} m-b-0`}>
            <BaseTypography variant="h3">
              <span
                className="primaryContrast"
                style={{ textTransform: 'uppercase' }}>
                {title}
              </span>
            </BaseTypography>
            {description && (
              <BaseTypography style={{ color: 'black' }} variant="smallText">{description}</BaseTypography>
            )}
          </div>
        </Grid>
        <Grid item>{rightContent}</Grid>
      </Grid>
      {/* <BaseDivider className={classes.divider} /> */}
    </>
  );
};
